import React from 'react'
import { Button, Icon } from 'antd'
import { transitions } from '../../helper/data.video'

const TransitionSelector = ({ onSelect, currentTransition }) => {
    return (
        <div className="transition-selector">
            <p className="selector-title">Select Transition</p>
            <div className="transition-options">
                <Button
                    key="none"
                    className={`transition-option ${!currentTransition ? 'selected' : ''
                        }`}
                    onClick={() => onSelect(null)} // This will remove the transition
                >
                    <Icon type="close" />
                    <span>None</span>
                </Button>
                {transitions.map(transition => (
                    <Button
                        key={transition.id}
                        className={`transition-option ${currentTransition === transition.id ? 'selected' : ''
                            }`}
                        onClick={() => onSelect(transition.id)}
                    >
                        <Icon type={transition.icon} />
                        <span>{transition.name}</span>
                    </Button>
                ))}
            </div>
        </div>
    )
}

export default TransitionSelector;